module.exports = __webpack_public_path__ + "img/cantidad_ventas.ce7ae700.png";